<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
<!-- Overlay End -->

<!-- Register & Login Start -->
<div class="section login-section-padding">
  <div class="container">

    <!-- Register & Login Wrapper Start -->
    <div class="register-login-wrapper">
      <div class="row align-items-center">
        <div class="col-lg-6">

          <!-- Register & Login Images Start -->
          <div class="register-login-images margin-top-0">
            <div class="shape-1">
              <img src="/assets/images/shape/shape-26.png" alt="Shape">
            </div>


            <div class="images">
              <img src="/assets/images/register-login.png" alt="Register Login">
            </div>
          </div>
          <!-- Register & Login Images End -->

        </div>
        <div class="col-lg-6">

          <!-- Register & Login Form Start -->
          <div class="register-login-form login-box">
            <h3 class="title">Register <span>Now</span></h3>

            <div class="form-wrapper">
              <form @submit.prevent="register">
                <div class="single-form">
                  <input type="text" v-model="userData.first_name" required placeholder="First Name">
                </div>
                <div class="single-form">
                  <input type="text" v-model="userData.last_name" required placeholder="Last Name">
                </div>
                <div class="single-form">
                  <input type="text" v-model="userData.email" placeholder="Email">
                </div>
                <div class="single-form">
                  <div class="row align-items-center">
                    <div class="col-lg-2 padding-right-0">
                      <div class="country-code-wrapper">
                        <select id="countryCode" v-model="userData.country_code" class="dropdown select-ui" required>
                          <option value='+93'>🇦🇫 Afghanistan (+93)</option>
                          <option value='+355'>🇦🇱 Albania (+355)</option>
                          <option value='+213'>🇩🇿 Algeria (+213)</option>
                          <option value='+1-684'>🇦🇸 American Samoa (+1-684)</option>
                          <option value='+376'>🇦🇩 Andorra (+376)</option>
                          <option value='+244'>🇦🇴 Angola (+244)</option>
                          <option value='+1-264'>🇦🇮 Anguilla (+1-264)</option>
                          <option value='+672'>🇦🇶 Antarctica (+672)</option>
                          <option value='+1-268'>🇦🇬 Antigua and Barbuda (+1-268)</option>
                          <option value='+54'>🇦🇷 Argentina (+54)</option>
                          <option value='+374'>🇦🇲 Armenia (+374)</option>
                          <option value='+297'>🇦🇼 Aruba (+297)</option>
                          <option value='+61'>🇦🇺 Australia (+61)</option>
                          <option value='+43'>🇦🇹 Austria (+43)</option>
                          <option value='+994'>🇦🇿 Azerbaijan (+994)</option>
                          <option value='+1-242'>🇧🇸 Bahamas (+1-242)</option>
                          <option value='+973'>🇧🇭 Bahrain (+973)</option>
                          <option value='+880'>🇧🇩 Bangladesh (+880)</option>
                          <option value='+1-246'>🇧🇧 Barbados (+1-246)</option>
                          <option value='+375'>🇧🇾 Belarus (+375)</option>
                          <option value='+32'>🇧🇪 Belgium (+32)</option>
                          <option value='+501'>🇧🇿 Belize (+501)</option>
                          <option value='+229'>🇧🇯 Benin (+229)</option>
                          <option value='+1-441'>🇧🇲 Bermuda (+1-441)</option>
                          <option value='+975'>🇧🇹 Bhutan (+975)</option>
                          <option value='+591'>🇧🇴 Bolivia (+591)</option>
                          <option value='+387'>🇧🇦 Bosnia and Herzegovina (+387)</option>
                          <option value='+267'>🇧🇼 Botswana (+267)</option>
                          <option value='+55'>🇧🇷 Brazil (+55)</option>
                          <option value='+246'>🇮🇴 British Indian Ocean Territory (+246)</option>
                          <option value='+673'>🇧🇳 Brunei (+673)</option>
                          <option value='+359'>🇧🇬 Bulgaria (+359)</option>
                          <option value='+226'>🇧🇫 Burkina Faso (+226)</option>
                          <option value='+257'>🇧🇮 Burundi (+257)</option>
                          <option value='+855'>🇰🇭 Cambodia (+855)</option>
                          <option value='+237'>🇨🇲 Cameroon (+237)</option>
                          <option value='+1'>🇨🇦 Canada (+1)</option>
                          <option value='+238'>🇨🇻 Cape Verde (+238)</option>
                          <option value='+1-345'>🇰🇾 Cayman Islands (+1-345)</option>
                          <option value='+236'>🇨🇫 Central African Republic (+236)</option>
                          <option value='+235'>🇹🇩 Chad (+235)</option>
                          <option value='+56'>🇨🇱 Chile (+56)</option>
                          <option value='+86'>🇨🇳 China (+86)</option>
                          <option value='+53'>🇨🇺 Cuba (+53)</option>
                          <option value='+61'>🇨🇽 Christmas Island (+61)</option>
                          <option value='+61'>🇨🇨 Cocos Islands (+61)</option>
                          <option value='+57'>🇨🇴 Colombia (+57)</option>
                          <option value='+269'>🇰🇲 Comoros (+269)</option>
                          <option value='+243'>🇨🇩 Congo (DRC) (+243)</option>
                          <option value='+242'>🇨🇬 Congo (Republic) (+242)</option>
                          <option value='+682'>🇨🇰 Cook Islands (+682)</option>
                          <option value='+506'>🇨🇷 Costa Rica (+506)</option>
                          <option value='+225'>🇨🇮 Cote d'Ivoire (+225)</option>
                          <option value='+385'>🇭🇷 Croatia (+385)</option>
                          <option value='+53'>🇨🇺 Cuba (+53)</option>
                          <option value='+357'>🇨🇾 Cyprus (+357)</option>
                          <option value='+420'>🇨🇿 Czech Republic (+420)</option>
                          <option value='+45'>🇩🇰 Denmark (+45)</option>
                          <option value='+253'>🇩🇯 Djibouti (+253)</option>
                          <option value='+1-767'>🇩🇲 Dominica (+1-767)</option>
                          <option value='+1-809'>🇩🇴 Dominican Republic (+1-809)</option>
                          <option value='+670'>🇹🇱 East Timor (+670)</option>
                          <option value='+593'>🇪🇨 Ecuador (+593)</option>
                          <option value='+20'>🇪🇬 Egypt (+20)</option>
                          <option value='+503'>🇸🇻 El Salvador (+503)</option>
                          <option value='+240'>🇬🇶 Equatorial Guinea (+240)</option>
                          <option value='+291'>🇪🇷 Eritrea (+291)</option>
                          <option value='+372'>🇪🇪 Estonia (+372)</option>
                          <option value='+251'>🇪🇹 Ethiopia (+251)</option>
                          <option value='+500'>🇫🇰 Falkland Islands (+500)</option>
                          <option value='+298'>🇫🇴 Faroe Islands (+298)</option>
                          <option value='+679'>🇫🇯 Fiji (+679)</option>
                          <option value='+358'>🇫🇮 Finland (+358)</option>
                          <option value='+33'>🇫🇷 France (+33)</option>
                          <option value='+594'>🇬🇫 French Guiana (+594)</option>
                          <option value='+689'>🇵🇫 French Polynesia (+689)</option>
                          <option value='+262'>🇹🇫 French Southern Territories (+262)</option>
                          <option value='+241'>🇬🇦 Gabon (+241)</option>
                          <option value='+220'>🇬🇲 Gambia (+220)</option>
                          <option value='+995'>🇬🇪 Georgia (+995)</option>
                          <option value='+49'>🇩🇪 Germany (+49)</option>
                          <option value='+233'>🇬🇭 Ghana (+233)</option>
                          <option value='+350'>🇬🇮 Gibraltar (+350)</option>
                          <option value='+44'>🇬🇧 Great Britain (UK) (+44)</option>
                          <option value='+30'>🇬🇷 Greece (+30)</option>
                          <option value='+299'>🇬🇱 Greenland (+299)</option>
                          <option value='+1-473'>🇬🇩 Grenada (+1-473)</option>
                          <option value='+590'>🇬🇵 Guadeloupe (+590)</option>
                          <option value='+1-671'>🇬🇺 Guam (+1-671)</option>
                          <option value='+502'>🇬🇹 Guatemala (+502)</option>
                          <option value='+224'>🇬🇳 Guinea (+224)</option>
                          <option value='+245'>🇬🇼 Guinea-Bissau (+245)</option>
                          <option value='+592'>🇬🇾 Guyana (+592)</option>
                          <option value='+509'>🇭🇹 Haiti (+509)</option>
                          <option value='+672'>🇭🇲 Heard and McDonald Islands (+672)</option>
                          <option value='+39'>🇻🇦 Holy See (Vatican City) (+39)</option>
                          <option value='+504'>🇭🇳 Honduras (+504)</option>
                          <option value='+852'>🇭🇰 Hong Kong (+852)</option>
                          <option value='+36'>🇭🇺 Hungary (+36)</option>
                          <option value='+354'>🇮🇸 Iceland (+354)</option>
                          <option value='+91'>🇮🇳 India (+91)</option>
                          <option value='+62'>🇮🇩 Indonesia (+62)</option>
                          <option value='+98'>🇮🇷 Iran (+98)</option>
                          <option value='+964'>🇮🇶 Iraq (+964)</option>
                          <option value='+353'>🇮🇪 Ireland (+353)</option>
                          <option value='+972'>🇮🇱 Israel (+972)</option>
                          <option value='+39'>🇮🇹 Italy (+39)</option>
                          <option value='+1-876'>🇯🇲 Jamaica (+1-876)</option>
                          <option value='+81'>🇯🇵 Japan (+81)</option>
                          <option value='+962'>🇯🇴 Jordan (+962)</option>
                          <option value='+7'>🇰🇿 Kazakhstan (+7)</option>
                          <option value='+254'>🇰🇪 Kenya (+254)</option>
                          <option value='+686'>🇰🇮 Kiribati (+686)</option>
                          <option value='+850'>🇰🇵 North Korea (+850)</option>
                          <option value='+82'>🇰🇷 South Korea (+82)</option>
                          <option value='+965'>🇰🇼 Kuwait (+965)</option>
                          <option value='+996'>🇰🇬 Kyrgyzstan (+996)</option>
                          <option value='+856'>🇱🇦 Laos (+856)</option>
                          <option value='+371'>🇱🇻 Latvia (+371)</option>
                          <option value='+961'>🇱🇧 Lebanon (+961)</option>
                          <option value='+266'>🇱🇸 Lesotho (+266)</option>
                          <option value='+231'>🇱🇷 Liberia (+231)</option>
                          <option value='+218'>🇱🇾 Libya (+218)</option>
                          <option value='+423'>🇱🇮 Liechtenstein (+423)</option>
                          <option value='+370'>🇱🇹 Lithuania (+370)</option>
                          <option value='+352'>🇱🇺 Luxembourg (+352)</option>
                          <option value='+853'>🇲🇴 Macau (+853)</option>
                          <option value='+389'>🇲🇰 Macedonia (+389)</option>
                          <option value='+261'>🇲🇬 Madagascar (+261)</option>
                          <option value='+265'>🇲🇼 Malawi (+265)</option>
                          <option value='+60'>🇲🇾 Malaysia (+60)</option>
                          <option value='+960'>🇲🇻 Maldives (+960)</option>
                          <option value='+223'>🇲🇱 Mali (+223)</option>
                          <option value='+356'>🇲🇹 Malta (+356)</option>
                          <option value='+692'>🇲🇭 Marshall Islands (+692)</option>
                          <option value='+596'>🇲🇶 Martinique (+596)</option>
                          <option value='+222'>🇲🇷 Mauritania (+222)</option>
                          <option value='+230'>🇲🇺 Mauritius (+230)</option>
                          <option value='+269'>🇾🇹 Mayotte (+269)</option>
                          <option value='+52'>🇲🇽 Mexico (+52)</option>
                          <option value='+691'>🇫🇲 Micronesia (+691)</option>
                          <option value='+373'>🇲🇩 Moldova (+373)</option>
                          <option value='+377'>🇲🇨 Monaco (+377)</option>
                          <option value='+976'>🇲🇳 Mongolia (+976)</option>
                          <option value='+1-664'>🇲🇸 Montserrat (+1-664)</option>
                          <option value='+212'>🇲🇦 Morocco (+212)</option>
                          <option value='+258'>🇲🇿 Mozambique (+258)</option>
                          <option value='+95'>🇲🇲 Myanmar (+95)</option>
                          <option value='+264'>🇳🇦 Namibia (+264)</option>
                          <option value='+674'>🇳🇷 Nauru (+674)</option>
                          <option value='+977'>🇳🇵 Nepal (+977)</option>
                          <option value='+31'>🇳🇱 Netherlands (+31)</option>
                          <option value='+599'>🇧🇶 Netherlands Antilles (+599)</option>
                          <option value='+687'>🇳🇨 New Caledonia (+687)</option>
                          <option value='+64'>🇳🇿 New Zealand (+64)</option>
                          <option value='+505'>🇳🇮 Nicaragua (+505)</option>
                          <option value='+227'>🇳🇪 Niger (+227)</option>
                          <option value='+234'>🇳🇬 Nigeria (+234)</option>
                          <option value='+683'>🇳🇺 Niue (+683)</option>
                          <option value='+672'>🇳🇫 Norfolk Island (+672)</option>
                          <option value='+1-670'>🇲🇵 Northern Mariana Islands (+1-670)</option>
                          <option value='+47'>🇳🇴 Norway (+47)</option>
                          <option value='+968'>🇴🇲 Oman (+968)</option>
                          <option value='+92'>🇵🇰 Pakistan (+92)</option>
                          <option value='+680'>🇵🇼 Palau (+680)</option>
                          <option value='+970'>🇵🇸 Palestine (+970)</option>
                          <option value='+507'>🇵🇦 Panama (+507)</option>
                          <option value='+675'>🇵🇬 Papua New Guinea (+675)</option>
                          <option value='+595'>🇵🇾 Paraguay (+595)</option>
                          <option value='+51'>🇵🇪 Peru (+51)</option>
                          <option value='+63'>🇵🇭 Philippines (+63)</option>
                          <option value='+64'>🇵🇳 Pitcairn Islands (+64)</option>
                          <option value='+48'>🇵🇱 Poland (+48)</option>
                          <option value='+351'>🇵🇹 Portugal (+351)</option>
                          <option value='+1-787'>🇵🇷 Puerto Rico (+1-787)</option>
                          <option value='+974'>🇶🇦 Qatar (+974)</option>
                          <option value='+262'>🇷🇪 Reunion (+262)</option>
                          <option value='+40'>🇷🇴 Romania (+40)</option>
                          <option value='+7'>🇷🇺 Russia (+7)</option>
                          <option value='+7'>🇷🇺 Russian Federation (+7)</option>
                          <option value='+250'>🇷🇼 Rwanda (+250)</option>
                          <option value='+290'>🇸🇭 Saint Helena (+290)</option>
                          <option value='+1-869'>🇰🇳 Saint Kitts and Nevis (+1-869)</option>
                          <option value='+1-758'>🇱🇨 Saint Lucia (+1-758)</option>
                          <option value='+508'>🇵🇲 Saint Pierre and Miquelon (+508)</option>
                          <option value='+1-784'>🇻🇨 Saint Vincent and the Grenadines (+1-784)</option>
                          <option value='+685'>🇼🇸 Samoa (+685)</option>
                          <option value='+378'>🇸🇲 San Marino (+378)</option>
                          <option value='+239'>🇸🇹 Sao Tome and Principe (+239)</option>
                          <option value='+966'>🇸🇦 Saudi Arabia (+966)</option>
                          <option value='+381'>🇷🇸 Serbia (+381)</option>
                          <option value='+221'>🇸🇳 Senegal (+221)</option>
                          <option value='+248'>🇸🇨 Seychelles (+248)</option>
                          <option value='+232'>🇸🇱 Sierra Leone (+232)</option>
                          <option value='+65'>🇸🇬 Singapore (+65)</option>
                          <option value='+421'>🇸🇰 Slovakia (+421)</option>
                          <option value='+386'>🇸🇮 Slovenia (+386)</option>
                          <option value='+677'>🇸🇧 Solomon Islands (+677)</option>
                          <option value='+252'>🇸🇴 Somalia (+252)</option>
                          <option value='+27'>🇿🇦 South Africa (+27)</option>
                          <option value='+500'>🇬🇸 South Georgia and South Sandwich Islands (+500)</option>
                          <option value='+34'>🇪🇸 Spain (+34)</option>
                          <option value='+94'>🇱🇰 Sri Lanka (+94)</option>
                          <option value='+249'>🇸🇩 Sudan (+249)</option>
                          <option value='+597'>🇸🇷 Suriname (+597)</option>
                          <option value='+47'>🇸🇯 Svalbard and Jan Mayen (+47)</option>
                          <option value='+268'>🇸🇿 Swaziland (+268)</option>
                          <option value='+46'>🇸🇪 Sweden (+46)</option>
                          <option value='+41'>🇨🇭 Switzerland (+41)</option>
                          <option value='+963'>🇸🇾 Syria (+963)</option>
                          <option value='+886'>🇹🇼 Taiwan (+886)</option>
                          <option value='+992'>🇹🇯 Tajikistan (+992)</option>
                          <option value='+255'>🇹🇿 Tanzania (+255)</option>
                          <option value='+66'>🇹🇭 Thailand (+66)</option>
                          <option value='+228'>🇹🇬 Togo (+228)</option>
                          <option value='+690'>🇹🇰 Tokelau (+690)</option>
                          <option value='+676'>🇹🇴 Tonga (+676)</option>
                          <option value='+1-868'>🇹🇹 Trinidad and Tobago (+1-868)</option>
                          <option value='+216'>🇹🇳 Tunisia (+216)</option>
                          <option value='+90'>🇹🇷 Turkey (+90)</option>
                          <option value='+993'>🇹🇲 Turkmenistan (+993)</option>
                          <option value='+1-649'>🇹🇨 Turks and Caicos Islands (+1-649)</option>
                          <option value='+688'>🇹🇻 Tuvalu (+688)</option>
                          <option value='+256'>🇺🇬 Uganda (+256)</option>
                          <option value='+380'>🇺🇦 Ukraine (+380)</option>
                          <option value='+971'>🇦🇪 United Arab Emirates (+971)</option>
                          <option value='+44'>🇬🇧 United Kingdom (+44)</option>
                          <option value='+1'>🇺🇸 United States (+1)</option>
                          <option value='+246'>🇺🇲 US Minor Outlying Islands (+246)</option>
                          <option value='+598'>🇺🇾 Uruguay (+598)</option>
                          <option value='+998'>🇺🇿 Uzbekistan (+998)</option>
                          <option value='+678'>🇻🇺 Vanuatu (+678)</option>
                          <option value='+418'>🇻🇦 Vatican City (+418)</option>
                          <option value='+58'>🇻🇪 Venezuela (+58)</option>
                          <option value='+84'>🇻🇳 Vietnam (+84)</option>
                          <option value='+1-284'>🇻🇬 Virgin Islands (British) (+1-284)</option>
                          <option value='+1-340'>🇻🇮 Virgin Islands (US) (+1-340)</option>
                          <option value='+681'>🇼🇫 Wallis and Futuna (+681)</option>
                          <option value='+212'>🇪🇭 Western Sahara (+212)</option>
                          <option value='+967'>🇾🇪 Yemen (+967)</option>
                          <option value='+243'>🇿🇲 Zaire (+243)</option>
                          <option value='+260'>🇿🇲 Zambia (+260)</option>
                          <option value='+263'>🇿🇼 Zimbabwe (+263)</option>
                          <!-- rest of your options -->
                        </select>
                        <span class="country-code-display">{{ userData.country_code }}</span>
                      </div>
                    </div>
                    <div class="col-lg-10">
                      <input type="text" v-model="userData.phone" placeholder="Phone">
                    </div>
                  </div>
                </div>
                <div class="single-form row gx-10">
                  <div class="col-lg-6">
                    <label for="userType">Select Account Type: </label>
                  </div>
                  <div class="col-lg-6 account-type-options">
                    <label class="radio-option">
                      <input type="radio" name="userType" value="individual" v-model="userData.org_or_ind" required>
                      Individual
                    </label>
                    <label class="radio-option">
                      <input type="radio" name="userType" value="organisation" v-model="userData.org_or_ind" required>
                      Organisation
                    </label>
                  </div>
                </div>
                <div class="single-form" v-show="userData.org_or_ind == 'organisation'">
                  <input type="text" v-model="userData.org" placeholder="Organisation Name">
                </div>
                <div class="single-form password-field">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="userData.password"
                    required
                    autocomplete="off"
                    placeholder="Password"
                  >
                  <button type="button" class="toggle-btn" @click="showPassword = !showPassword">
                    {{ showPassword ? "🔒" : "👁️" }}
                  </button>
                  <small class="password-hint">Must be at least 8 characters and include a letter, a number, and a special character.</small>
                </div>

                <div v-if="errors.length>0">
                  <p v-for='error in errors' :key='error' class="error_message">{{error}}</p>
                </div>
                <div v-if="showResendOption" class="single-form resend-verification">
                  <button type="button" class="btn-link" @click="handleResend" :disabled="resending">
                    {{ resending ? 'Sending...' : 'Resend verification email' }}
                  </button>
                  <p v-if="resendMessage" class="resend-message">{{ resendMessage }}</p>
                </div>


                <div class="single-form">
                  <button type="submit" class="btn btn-primary btn-hover-dark w-100">Register Now</button>
                </div>
              </form>

              

            </div>
          </div>
          <!-- Register & Login Form End -->

        </div>
      </div>
    </div>
    <!-- Register & Login Wrapper End -->

  </div>
</div>
<!-- Register & Login End -->
<!-- Registration Success Modal -->
<div v-if="showSuccessModal" class="modal-overlay">
  <div class="modal-content" @click.stop>
    <div class="register-login-form login-box success-modal">
      <div class="success-icon">
        <i class="icofont-envelope"></i>
      </div>
      <h3 class="title">One Last Step <span>to Get Started</span></h3>
      <p class="modal-message-primary">
        Please check your email to verify your account.
      </p>
      <p class="modal-message-secondary">
        Thank you for registering with COLREGs!
      </p>
      <div class="form-wrapper">
        <div class="single-form">
          <button 
            class="btn btn-primary btn-hover-dark w-100" 
            @click="goToLogin">
            Go to Login
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- GDPR Consent Modal -->
<div v-if="showGdprModal" class="gdpr-modal-overlay">
  <div class="gdpr-modal-content" @click.stop>
    <h3 class="gdpr-modal-title">Data Protection Notice</h3>

    <div class="gdpr-modal-body">
      <p>Jupiter Maritime Ltd (trading as COLREGs) is subject to the provisions of the General Data Protection Regulation (GDPR). The personal data you provide to us will be processed on a 'legitimate interests' basis under Article 6(1) of the GDPR. This enables us to provide you with the information and services required to maintain your account and access to our maritime training platform.</p>
      <p>You will receive communications from us to let you know about relevant activities, products, services, and the status of your account. You can read more about how we handle your data in our <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>.</p>
    </div>

    <label class="gdpr-checkbox-label">
      <input type="checkbox" v-model="gdprAccepted">
      I agree to Jupiter Maritime Ltd (COLREGs) processing my personal data under the provisions of the GDPR, in order to provide me with services relating to my account.
    </label>

    <div class="gdpr-modal-actions">
      <button class="btn btn-outline-secondary" @click="declineGdpr">Decline</button>
      <button class="btn btn-primary btn-hover-dark" :disabled="!gdprAccepted" @click="confirmRegistration">Agree &amp; Continue</button>
    </div>
  </div>
</div>
</template>

<script>
import { createUser, resendVerificationEmail } from '@/services/userService';
export default {
name: 'Register',
data() {
  return {
    user_exists: false,
    errors: [],
    showSuccessModal: false,
    showPassword: false,
    showGdprModal: false,
    gdprAccepted: false,
    resending: false,
    resendMessage: "",
    userData: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      country_code: '+1',
      phone: '',
      org_or_ind: 'individual',
      role: 'member',
      org: null,
      gdpr_consent: false,
    }
  };
},
computed: {
  showResendOption() {
    return this.errors.includes('User already exists.');
  }
},
methods: {

  async handleResend() {
    this.resending = true;
    this.resendMessage = "";
    try {
      const response = await resendVerificationEmail(this.userData.email);
      this.resendMessage = response.message || 'Verification email sent. Please check your inbox.';
    } catch (err) {
      this.resendMessage = err.response?.data?.message || 'Failed to resend verification email. Please try again.';
    } finally {
      this.resending = false;
    }
  },

  validateForm() {
    this.errors = [];
    const requiredFields = ['first_name', 'last_name', 'email', 'password', 'country_code', 'phone', 'org_or_ind'];

    requiredFields.forEach((field) => {
      if (!this.userData[field].trim()) {
        this.errors.push(`${field.replace('_', ' ')} is required`);
      }
    });

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (this.userData.email && !emailRegex.test(this.userData.email)) {
      this.errors.push('Invalid email format');
    }

    if (this.userData.phone && isNaN(this.userData.phone)) {
      this.errors.push('Phone number must be numeric');
    }

    // Validate password: min 8 chars, at least 1 letter, 1 number, 1 special character
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    if (this.userData.password && !passwordRegex.test(this.userData.password)) {
      this.errors.push('Password must be at least 8 characters and include a letter, a number, and a special character');
    }

    return this.errors.length === 0;
  },

  declineGdpr() {
    this.showGdprModal = false;
    this.gdprAccepted = false;
  },

  register() {
    if (this.userData.org !== null) {
      this.userData.role = 'manager'
    }

    if (this.validateForm()) {
      // Show the GDPR consent modal; the actual registration call happens once the user agrees
      this.showGdprModal = true;
    }
  },

  async confirmRegistration() {
    if (!this.gdprAccepted) return;

    this.userData.gdpr_consent = true;
    this.showGdprModal = false;
    this.resendMessage = "";

    try {
      const response = await createUser(this.userData);
      console.log('User registered successfully:', response.first_name);
      this.errors = [];

      // Show success modal instead of immediate redirect
      this.showSuccessModal = true;

    } catch (err) {
      console.log(err);
      if (err.response?.data?.message == 'User already exists.'){
        this.errors.push(err.response.data.message);
      }else{
        this.errors.push('Registration failed. Please try again.');
      }
    }
  },

  goToLogin() {
    this.$router.push('/login');
  }
}
};
</script>

<style scoped>
.password-hint {
display: block;
margin-top: 6px;
font-size: 12px;
color: #666;
}

.resend-verification {
margin-top: 10px;
}

.btn-link {
background: none;
border: none;
padding: 0;
color: #309255;
text-decoration: underline dotted #309255;
cursor: pointer;
font-size: 14px;
}

.btn-link:disabled {
opacity: 0.6;
cursor: not-allowed;
}

.resend-message {
margin-top: 8px;
font-size: 13px;
color: #52565b;
}

/* GDPR Consent Modal */
.gdpr-modal-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.7);
display: flex;
justify-content: center;
align-items: center;
z-index: 9999;
padding: 20px;
}

.gdpr-modal-content {
background: #fff;
border-radius: 10px;
width: fit-content;
max-width: 560px;
min-width: 300px;
max-height: 90vh;
overflow-y: auto;
padding: 30px;
box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.gdpr-modal-title {
margin: 0 0 16px;
color: #212832;
font-weight: 700;
}

.gdpr-modal-body p {
font-size: 14px;
color: #444;
line-height: 1.6;
margin-bottom: 14px;
}

.gdpr-modal-body p:last-child {
margin-bottom: 0;
}

.gdpr-checkbox-label {
display: flex;
align-items: flex-start;
gap: 8px;
font-size: 14px;
color: #333;
cursor: pointer;
margin: 18px 0 20px;
}

.gdpr-checkbox-label input[type="checkbox"] {
margin-top: 3px;
width: 16px;
height: 16px;
flex-shrink: 0;
cursor: pointer;
}

.gdpr-modal-actions {
display: flex;
justify-content: flex-end;
gap: 10px;
}

.gdpr-modal-actions .btn:disabled {
opacity: 0.6;
cursor: not-allowed;
}

@media (max-width: 575px) {
.gdpr-modal-content {
  padding: 20px;
  width: 100%;
}
.gdpr-modal-actions {
  flex-direction: column-reverse;
}
.gdpr-modal-actions .btn {
  width: 100%;
}
}

.password-field {
position: relative;
}

.password-field input {
width: 100%;
padding-right: 40px;
}

.toggle-btn {
position: absolute;
right: 10px;
top: 18px;
transform: translateY(-50%);
background: none;
border: none;
cursor: pointer;
}

.account-type-options {
display: flex;
align-items: center;
gap: 20px;
}

.radio-option {
display: flex;
align-items: center;
gap: 6px;
font-weight: normal;
cursor: pointer;
}

.radio-option input[type="radio"] {
width: auto;
margin: 0;
}

/* Modal Overlay */
.modal-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.7);
display: flex;
justify-content: center;
align-items: center;
z-index: 9999;
animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
from {
  opacity: 0;
}
to {
  opacity: 1;
}
}

/* Modal Content */
.modal-content {
position: relative;
background: #fff;
padding: 40px;
border-radius: 10px;
max-width: 500px;
width: 90%;
box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
animation: slideUp 0.3s ease;
}

@keyframes slideUp {
from {
  transform: translateY(50px);
  opacity: 0;
}
to {
  transform: translateY(0);
  opacity: 1;
}
}

/* Success Icon */
.success-icon {
text-align: center;
margin-bottom: 20px;
}

.success-icon i {
font-size: 80px;
color: #309255;
animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
from {
  transform: scale(0);
}
to {
  transform: scale(1);
}
}

/* Success Modal */
.success-modal .title {
text-align: center;
margin-bottom: 20px;
}

/* Modal Message */
.modal-message-primary {
text-align: center;
color: #1a1a1a;
font-size: 22px;
font-weight: 700;
line-height: 1.4;
margin-bottom: 12px;
}

.modal-message-secondary {
text-align: center;
color: #666;
font-size: 15px;
margin-bottom: 30px;
}

/* Button */
.success-modal .single-form {
margin-bottom: 0;
}

/* Responsive */
@media (max-width: 768px) {
.modal-content {
  padding: 30px 20px;
}

.success-icon i {
  font-size: 60px;
}
}
</style>